import React from 'react';
import { Lock, Zap, Shield } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="relative bg-[#0D0D1A] pt-2 md:pt-4 pb-5 md:pb-7 px-4 overflow-hidden" data-id="element-261" data-mp="19imb9jxisbne">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-262" data-mp="1ehgrce43rm3t"></div>

      <div className="relative max-w-xl mx-auto" data-id="element-263" data-mp="1jas38tnrut2l">
        <h2 className="font-display font-bold text-white text-center text-[22px] md:text-4xl mb-6 md:mb-8 whitespace-nowrap" data-id="element-264" data-mp="1n9irsce692e3">
          🛒 ELEGÍ TU MEGAPACK
        </h2>

        <div className="relative bg-[#1C1040] border-2 border-gold rounded-2xl p-5 md:p-7 text-center featured-card-glow" data-id="element-265" data-mp="1x86um3xl5ax7">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-[#1a0533] font-bold text-[10px] md:text-xs tracking-widest uppercase px-4 py-1 rounded-full shadow-lg whitespace-nowrap" data-id="element-266" data-mp="226rwe7shk2nr">
            ⭐ OFERTA DE LANZAMIENTO
          </div>

          <div className="text-gold font-bold text-[11px] md:text-xs tracking-widest uppercase mb-2 mt-1" data-id="element-267" data-mp="1mgod16i4d1i8">
            🍱 MEGAPACK VIANDA RESUELTA
          </div>
          <h3 className="font-display font-bold text-white text-xl md:text-3xl leading-tight mb-2" data-id="element-268" data-mp="1hodhefuew1vh">
            Todo resuelto para tus viandas
          </h3>
          <p className="text-gold font-semibold text-[13px] md:text-base mb-3" data-id="element-269" data-mp="17sabr00cpl3s">
            6 Tomos + 5 Bonos estratégicos
          </p>
          <p className="text-white/70 text-[12px] md:text-sm leading-snug mb-4" data-id="element-270" data-mp="25f0q33c5ivj3">
            El sistema completo de viandas para padres y madres separados. Más
            de 180 recetas y soluciones listas para usar desde hoy.
          </p>

          <div className="flex items-baseline justify-center gap-2 mb-4" data-id="element-271" data-mp="1rfrhopu6t5po">
            <span className="text-white/40 line-through text-base md:text-lg" data-id="element-272" data-mp="1rhu6x7nimutc">
              USD 49.00
            </span>
            <span className="font-display font-black text-gold text-4xl md:text-6xl leading-none" data-id="element-273" data-mp="g0m58u497ssv">
              USD 19
            </span>
          </div>

          <a href="https://megapack-vianda-resuelta.impultienda.ar/checkout" className="cta-btn inline-flex w-full items-center justify-center text-white font-display font-extrabold text-sm md:text-lg uppercase tracking-wide px-4 py-3.5 rounded-full text-center" data-id="element-274" data-mp="hib1topqybp1">
            → QUIERO MI MEGAPACK AHORA
          </a>
        </div>

        <div className="mt-6 md:mt-8 text-center" data-id="element-275" data-mp="3uwedie5synrp">
          <p className="italic text-white/60 text-[10px] md:text-xs leading-snug mb-2" data-id="element-276" data-mp="3uul4is7pvrgj">
            El precio es en dólares americanos. El cobro se realiza en la moneda
            de tu país al tipo de cambio del momento.
          </p>
          <div className="flex flex-nowrap justify-center items-center gap-x-2 md:gap-x-4 text-white/80 text-[10px] md:text-sm font-medium whitespace-nowrap" data-id="element-277" data-mp="3px1rfvmr9kq6">
            <span className="flex items-center gap-1" data-id="element-278" data-mp="3bzwow5m933zo">
              <Lock className="w-3 h-3 md:w-3.5 md:h-3.5 text-gold shrink-0" data-id="element-279" data-mp="3fznew73ydg35" />
              Pago seguro
            </span>
            <span className="text-white/20" data-id="element-280" data-mp="2xbmw0hhf7dx0">|</span>
            <span className="flex items-center gap-1" data-id="element-281" data-mp="2sc9zt64nsuhr">
              <Zap className="w-3 h-3 md:w-3.5 md:h-3.5 text-gold shrink-0" data-id="element-282" data-mp="2sduucvqz4dfm" />
              Acceso en 5 min
            </span>
            <span className="text-white/20" data-id="element-283" data-mp="31coma8td0fmu">|</span>
            <span className="flex items-center gap-1" data-id="element-284" data-mp="31bx2dv94k6ce">
              <Shield className="w-3 h-3 md:w-3.5 md:h-3.5 text-gold shrink-0" data-id="element-285" data-mp="3g9pfyhv42kny" />
              Garantía 7 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}